import React, { Component } from 'react';

export default class ChildWrapperPage extends Component {
  render() {
    return (
      <div>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/ChildWrapperPage.js